import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class LoadingService {
    public isLoading: WritableSignal<boolean> = signal(false);

    public showLoader(): void {
        this.isLoading.set(true);
    }

    public dismissLoader(): void {
        this.isLoading.set(false);
    }
}
